<template>
  <div id="app" :class="{ 'gs18-HeaderFog': isMobile }">
    <template v-if="showEn">
      <Header3 :isFixed="isFixed" :scrollTop="scrollTop" @changeMobile="changeMobile"></Header3>
    </template>
    <template v-if="!showEn">
      <Header2 :isFixed="isFixed" :scrollTop="scrollTop" @changeMobile="changeMobile"></Header2>
    </template>
    <router-view />
    <template v-if="showEn">
      <Footer3></Footer3>
    </template>
    <template v-if="!showEn">
      <!-- 链接 -->
      <Link>
      </Link>
      <Footer2></Footer2>
    </template>
    <div :class="['loader', $store.state.loading ? '' : 'remove-loader']">
      <img v-if="isPath == 'Pc'" src="./assets/img/load.png" alt="loading" />
      <img v-if="isPath == 'Moblie'" src="./assets/img/loading3.png" alt="loading" />
    </div>
  </div>
</template>

<script>
import Dialog from "./components/Dialog.vue";
import IndustryTrendsVue from "./view/NewsInformation/IndustryTrends.vue";
import Link from "@/components/link.vue";
export default {
  name: "App",
  data() {
    return {
      scrollTop: 0,
      isFixed: false,
      isMobile: false,
      loading: true,
      isPath: 'Pc',
      showEn: false,
    };
  },
  mounted() {
    // loading加载两秒
    setTimeout(() => {
      this.$store.state.loading = false
    }, 3000);
    const isPath = navigator.userAgent.match(
      // match方法可在字符串内检索指定的值，
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? "Moblie"
      : "Pc";
    this.isPath = isPath;
    if (isPath == "Pc") {
      window.addEventListener(
        "scroll",
        () => {
          if (document.documentElement.scrollTop || document.body.scrollTop) {
            this.scrollTop =
              document.documentElement.scrollTop || document.body.scrollTop;
            if (this.scrollTop >= 80) {
              this.isFixed = true;
            } else {
              this.isFixed = false;
            }
          } else {
            this.isFixed = false;
          }
        },
        true
      );
    }

    let html = document.getElementById("app");
    let width =
      document.body.clientWidth || document.documentElement.clientWidth;
    if ((width / 1920) * 16 < 8) {
      html.style.fontSize = 7.8125 + "px";
    } else {
      html.style.fontSize = (width / 1920) * 16 + "px";
    }
    // this.$refs.myDialog.dialogShow();
  },
  components: {
    Dialog,
    Link
  },
  methods: {
    showMenu(val) {
      this.isMobile = val;
    },
    changeMobile(val) {
      this.isMobile = val;
    },
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {
      if (to.path.includes('/en')) {
        this.showEn = true
      } else {
        this.showEn = false
      }
    },
  }
};
</script>

<style lang="less">
@keyframes navbanner {
  0% {
    width: 0;
    background-color: red;
  }

  100% {
    width: 8vw;
    background-color: red;
  }
}

@keyframes rotation {
  to {
    transform: rotate(360deg);
  }
}

/* 轮播图 */
#swiper .swiper-pagination-bullet {
  background: rgba(255, 255, 255, 0.35);
  width: 8vw;
  border-radius: 2px;
  height: calc(8em / 16);
}

#swiper .swiper-pagination-bullet-active {
  /* background: #fff; */
  opacity: 1;
  border-radius: 2px;
  position: relative;
  /* animation: navbanner 5s 1 forwards !important; */
}

#swiper .swiper-pagination-bullet-active::after {
  content: "";
  width: 8vw;
  height: calc(8em / 16);
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 2px;
  animation: navbanner 8s 1 forwards;
}

.swiper-container-horizontal>.swiper-scrollbar {
  width: 20% !important;
  left: 50% !important;
  transform: translate(-50%) !important;
  bottom: 0 !important;
}

.swiper-scrollbar-drag {
  background-color: red !important;
}

.maxiez_mjscon .swiper-pagination {
  position: relative;
  margin-top: 20px;
}

.maxiez_mjscon .swiper-pagination-bullet,
.maxiez_czfa .swiper-pagination-bullet,
.maxiez_czxt .swiper-pagination-bullet,
.maxiez_rxh .swiper-pagination-bullet,
.swiper-containerczjs .swiper-pagination-bullet {
  width: 50px;
  height: 6px;
  background: #cccccc;
  margin: 0 5px;
  border-radius: 0;
  opacity: 1;
  display: inline-block;
}

#swiper_2 .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border-radius: 15px;
}

#swiper_2 .swiper-pagination-bullets {
  bottom: 140px !important;
}

#swiper_3 .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border-radius: 15px;
}

#swiper_3 .swiper-pagination-bullets {
  bottom: 140px !important;
}

@media only screen and (max-width: 768px) {
  #swiper_2 .swiper-pagination-bullets {
    bottom: 190px !important;
  }

  #swiper_3 .swiper-pagination-bullets {
    bottom: 125px !important;
  }
}

.maxiez_mjscon .swiper-pagination-bullet-active,
.maxiez_czfa .swiper-pagination-bullet-active,
.maxiez_czxt .swiper-pagination-bullet-active,
.maxiez_rxh .swiper-pagination-bullet-active,
.swiper-containerczjs .swiper-pagination-bullet-active {
  background: #e00024;
}

@media only screen and (max-width: 768px) {

  .maxiez_mjscon .swiper-pagination-bullet,
  .maxiez_czfa .swiper-pagination-bullet,
  .maxiez_czxt .swiper-pagination-bullet,
  .maxiez_rxh .swiper-pagination-bullet,
  .swiper-containerczjs .swiper-pagination-bullet {
    width: 30px;
    height: 4px;
    background: #cccccc;
    margin: 0 5px;
    border-radius: 0;
    opacity: 1;
    display: inline-block;
  }

  .maxiez_mjscon .swiper-pagination-bullet-active,
  .maxiez_czfa .swiper-pagination-bullet-active,
  .maxiez_czxt .swiper-pagination-bullet-active,
  .maxiez_rxh .swiper-pagination-bullet-active,
  .swiper-containerczjs .swiper-pagination-bullet-active {
    background: #e00024;
  }
}

.swiper-pagination3,
.swiper-pagination4 {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 5% !important;
  z-index: 10;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999999;
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 1;
  transition: all 0.5s ease;
  user-select: none;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
    margin: auto;
  }
}

.remove-loader {
  opacity: 0;
  z-index: -100;
}
</style>



// WEBPACK FOOTER //
// src/App.vue